import { filterProperReleases } from "../container/filterProperReleases";
import { sortVersion } from "./sortVersion";
function updateVersion(currentVersion, version) {
    currentVersion.entries.push(version);
    version.featureApps &&
        (currentVersion.featureApps = updateArray(currentVersion.featureApps, version.featureApps, (f1, f2) => f1.defaultId === f2.defaultId));
    currentVersion.pageIds = updateArray(currentVersion.pageIds, version.pageIds ?? undefined, (f1, f2) => f1.defaultId === f2.defaultId);
    currentVersion.serviceConfigurations = updateArray(currentVersion.serviceConfigurations, version.serviceConfigurations ?? undefined, (f1, f2) => f1.id === f2.id);
    currentVersion.featureServices = updateArray(currentVersion.featureServices, version.featureServices ?? undefined, (f1, f2) => f1.name === f2.name);
}
function createVersion(appVersion) {
    return {
        entries: [appVersion],
        featureApps: appVersion.featureApps || [],
        pageIds: appVersion.pageIds || [],
        featureServices: appVersion.featureServices || [],
        serviceConfigurations: appVersion.serviceConfigurations || [],
        version: appVersion.version ?? undefined,
        libs: appVersion.libs ?? undefined,
    };
}
function updateVersions(versions, appVersions) {
    appVersions.forEach((appVersion) => {
        const candidates = versions.filter((v) => v.version === appVersion.version);
        if (candidates.length > 0) {
            updateVersion(candidates[0], appVersion);
        }
        else {
            versions.push(createVersion(appVersion));
        }
    });
}
export function mergeFeatureAppsOfDeploymentSet(apps) {
    const deploymentSet = apps[0].general.deploymentSet;
    if (!deploymentSet) {
        return undefined;
    }
    const deployments = apps[0].deployments;
    const featureAppsOfDeploymentSet = apps.reduce((prevSet, currSet) => {
        currSet.configurations?.forEach((c) => prevSet.configurations.push(c));
        prevSet.featureApps.push(currSet.general);
        prevSet.teams.add(currSet.general.team ?? undefined);
        prevSet.repositoryUrls.add(currSet.general.repositoryUrl ?? undefined);
        prevSet.releasePageUrls.add(currSet.latestVersion?.releasePageUrl ?? undefined);
        if (!prevSet.latestVersion) {
            const latestVersion = createVersion(currSet.latestVersion);
            prevSet.latestVersion = latestVersion;
        }
        else {
            const latestVersion = prevSet.latestVersion;
            updateVersion(latestVersion, currSet.latestVersion);
        }
        updateVersions(prevSet.versions, currSet.versions ?? []);
        return prevSet;
    }, {
        deploymentSet,
        teams: new Set(),
        repositoryUrls: new Set(),
        releasePageUrls: new Set(),
        featureApps: [],
        configurations: [],
        versions: [],
    });
    featureAppsOfDeploymentSet.versions = filterProperReleases(featureAppsOfDeploymentSet.versions);
    featureAppsOfDeploymentSet.versions.sort((v1, v2) => v1.version && v2.version ? sortVersion(v1.version, v2.version) : 0);
    deployments && (featureAppsOfDeploymentSet.deployments = deployments);
    return featureAppsOfDeploymentSet;
}
function updateArray(currentArray, newArray, equals) {
    if (newArray) {
        const updateArray = [...currentArray];
        newArray
            .filter((t) => currentArray.filter((existing) => equals(t, existing)).length == 0)
            .forEach((t) => {
            updateArray.push(t);
        });
    }
    return currentArray;
}
